'use client'

import { Pill } from '@repo/ui/Pill'
import { useTheme } from '@mui/material'
import MUIStack from '@mui/material/Stack'
import MUITooltip from '@mui/material/Tooltip'
import MUITypography from '@mui/material/Typography'

export const BankFeedsSubTitleModule = ({ bankFeed }: BankFeedsSubTitleModuleProps) => {
  const theme = useTheme()

  return (
    <MUIStack data-testid="BankFeedsSubTitleModule">
      <MUIStack
        direction="row"
        alignItems="baseline"
        justifyContent="flex-start"
        sx={{ p: '0.25rem 1rem', whiteSpace: 'nowrap' }}
      >
        <MUITooltip title={bankFeed?.institutionName ?? ''} arrow placement="top">
          <MUITypography
            variant="body2"
            sx={{
              p: '0',
              m: 0,
              color: 'text.secondary',
              maxWidth: '50%',
              textOverflow: 'ellipsis',
              overflow: 'hidden'
            }}
          >
            {bankFeed?.institutionName ?? ''}
          </MUITypography>
        </MUITooltip>
        <MUITypography variant="body2" sx={{ p: '0 0.5rem', m: 0, color: 'text.secondary' }}>
          |
        </MUITypography>
        <MUITypography variant="body2" sx={{ p: '0', m: 0, color: 'text.secondary' }}>
          {bankFeed?.isoCurrencyCode ?? ''}
        </MUITypography>
      </MUIStack>
      <MUIStack
        direction="row"
        alignItems="baseline"
        justifyContent="flex-start"
        sx={{ p: '0.5rem 1rem', whiteSpace: 'nowrap' }}
      >
        <MUITooltip title={bankFeed?.name ?? ''} arrow placement="top">
          <MUITypography
            variant="body2"
            sx={{
              p: '0',
              m: 0,
              color: 'text.secondary',
              maxWidth: '50%',
              textOverflow: 'ellipsis',
              overflow: 'hidden'
            }}
          >
            {bankFeed?.name ?? ''}
          </MUITypography>
        </MUITooltip>
        <MUITypography variant="body2" sx={{ p: '0 0.5rem', m: 0, color: 'text.secondary' }}>
          |
        </MUITypography>
        <MUITypography variant="body2" sx={{ p: '0', m: 0, color: 'text.secondary' }}>
          {bankFeed?.mask ? `****${bankFeed.mask}` : ''}
        </MUITypography>
      </MUIStack>
      {bankFeed?.ospreyBankName && (
        <Pill
          label={bankFeed?.ospreyBankName ?? ''}
          color={theme.palette.text.primary}
          backgroundColor={theme.palette.grey[300]}
          sx={{
            height: '25px',
            width: 'fit-content',
            maxWidth: 'calc(100% - 2rem)',
            m: '0.5rem 1rem',
            [`& span`]: { fontSize: '0.75rem' }
          }}
        />
      )}
    </MUIStack>
  )
}

type BankFeedsSubTitleModuleProps = {
  bankFeed: any
}
